// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"87b3f630","955":"d816667a"}[chunkId] + ".chunk.css";
};